import script from "./TimerRings.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerRings.vue?vue&type=script&setup=true&lang=ts"

import "./TimerRings.vue?vue&type=style&index=0&id=55d41632&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d41632"]])

export default __exports__